import { render, staticRenderFns } from "./RealTimeF2FSettingMenu.vue?vue&type=template&id=ea242550"
import script from "./RealTimeF2FSettingMenu.vue?vue&type=script&lang=js"
export * from "./RealTimeF2FSettingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports